// Type definitions
export type ContainerDivProps = {
	classes?: string;
	children?: React.ReactNode;
	testid?: string;
	onClick?: React.MouseEventHandler<HTMLDivElement>;
};

// Component
const ContainerDiv = ({ classes, children, testid, onClick }: ContainerDivProps): JSX.Element => {
	return (
		<div className={classes} data-testid={testid} onClick={onClick}>
			<>{children}</>
		</div>
	);
};

export default ContainerDiv;
